<template>
  <div style="height: 100%">
    <!-- HEADER -->
    <v-row class="rowView">
      <v-col
        class="colView h5"
        :cols="12"
        style="color: var(--color-text)"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              style="cursor: pointer;"
              v-on="on"
            >
              Details
            </span>
          </template>
          <span>
            Details contain information about selected cleaning event.
          </span>
        </v-tooltip>

        <InfoIcon
          :info-data="infoData"
        />
      </v-col>
    </v-row>

    <!-- TOP CARDS -->
    <v-row
      class="rowView"
      style="height: calc(35% - 25px)"
    >
      <v-col
        v-for="param in eventParams"
        :key="param"
        :cols="3"
      >
        <CardSingleValue
          val-class="h4"
          :card-data="selEventData[param]"
        />
      </v-col>
    </v-row>

    <!-- TABLE -->
    <v-row
      class="rowView"
      style="height: 65%"
    >
      <v-col
        :cols="12"
        class="colView"
      >
        <v-card
          ref="parentDiv"
          v-resize="onResize"
          style="background-color: var(--color-bg) !important"
        >
          <v-data-table
            style="height: calc(100% - 25px); width: 100%"
            :height="dataTableHeight - 30"
            single-select
            disable-pagination
            hide-default-footer
            :headers="detHeaders"
            :items="detItems"
          >
            <template v-slot:body="{ headers, items }">
              <tbody style="color: var(--color-text)">
                <tr
                  v-for="item in items"
                  :key="item.part"
                >
                  <td class="tableHeader bodyText">{{ item.part }}</td>
                  <td
                    v-for="n in headers.length - 1"
                    :key="n"
                  >
                    <div
                      class="circle ma-auto"
                      :style="
                        'border-color:' +
                          cellColor(item[headers[n].value]) +
                          '; background-color:' +
                          cellColor(item[headers[n].value]) +
                          ';'
                      "
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>

          <!-- LEGEND WITH STYLED TOOLTIP -->
          <v-tooltip
            top
            open-on-hover
            :close-delay="100"
            :open-delay="150"
            right
            nudge-right="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-row
                style="height: 25px"
                class="rowView pa-1"
                v-bind="attrs"
                v-on="on"
              >
                <v-spacer />
                <div
                  v-for="label in Object.keys(colorDict)"
                  :key="label"
                  class="colView"
                >
                  <v-row
                    style="height: 100%"
                    class="rowView"
                  >
                    <div
                      class="smallCircle ma-auto"
                      :style="
                        'border-color:' +
                          colorDict[label] +
                          '; background-color:' +
                          colorDict[label] +
                          ';'
                      "
                    />
                    <div
                      class="description bodyText my-auto mx-2"
                      style="color: var(--color-text) !important"
                    >
                      {{ label }}
                    </div>
                  </v-row>
                </div>
              </v-row>
            </template>

            <!-- TOOLTIP CONTENT -->
            <div
              style="
                background: #1e2f3f;
                padding: 14px 16px;
                border-radius: 8px;
                color: white;
                font-size: 13px;
                line-height: 1.6;
              "
            >
              <div style="font-weight: 600; margin-bottom: 6px;">
                Fouling Levels
              </div>

              <div style="display: flex; align-items: center; margin-bottom: 4px;">
                <div
                  class="smallCircle mr-2"
                  :style="'border-color:' + colorDict['Light'] + '; background-color:' + colorDict['Light']"
                />
                Light &lt; 40%
              </div>

              <div style="display: flex; align-items: center; margin-bottom: 4px;">
                <div
                  class="smallCircle mr-2"
                  :style="'border-color:' + colorDict['Medium'] + '; background-color:' + colorDict['Medium']"
                />
                Medium &lt; 60%
              </div>

              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <div
                  class="smallCircle mr-2"
                  :style="'border-color:' + colorDict['Heavy'] + '; background-color:' + colorDict['Heavy']"
                />
                Heavy &lt; 80%
              </div>

              <div style="font-weight: 600; margin-bottom: 4px;">
                Positions
              </div>

              <div>VS = Vertical Sides</div>
              <div>FB = Flat Bottom</div>
              <div>PR = Propeller</div>
            </div>
          </v-tooltip>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CardSingleValue from "../../../components/CardSingleValue.vue";
import InfoIcon from "@/core/InfoIcon.vue";

export default {
  name: "FoulingDetailsPanel",
  components: { CardSingleValue, InfoIcon },
  props: {
    infoData: { type: [Object, String, Array, Number, Boolean], default: null },
    eventParams: { type: Array, required: true },
    selEventData: { type: Object, required: true },
    detHeaders: { type: Array, required: true },
    detItems: { type: Array, required: true },
    colorDict: { type: Object, required: true },
    dataTableHeight: { type: Number, required: true },
  },
  methods: {
    onResize() {
      this.$emit("resize");
    },
    cellColor(value) {
      if (value in this.colorDict) return this.colorDict[value];
      return this.colorDict["No Data"];
    },
  },
};
</script>

<style scoped>

.legend-tooltip {
  opacity: 1 !important;
}

.v-data-table {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}

.v-data-table >>> th {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.v-data-table td {
  border-bottom: 1px solid var(--color-border) !important;
  color: var(--color-text) !important;
}

.v-data-table tbody tr:hover {
  background-color: var(--color-overlay) !important;
}

.v-data-table tbody tr:nth-of-type(odd) {
  background-color: var(--color-surface) !important;
}

.v-data-table tbody tr:nth-of-type(even) {
  background-color: var(--color-bg) !important;
}
</style>
